/**
 * Leads list: end users with userType = 'lead'.
 * Reuses the customers list grid, only the data source, filters storage
 * and the "new" popup (pre-set as lead) differ.
 */
define('customersLeadsListView',[
  'module',
  'underscore',
  'windows',
  'app',
  'settings',
  'customersListView',
  'template!customersLeadsListView',
  'customersPopupEditView'
], function (
  module,
  _,
  Windows,
  App,
  Settings,
  CustomersListView,
  viewTpl,
  EditView
) {
  'use strict';

  var LeadsListView = CustomersListView.extend({
    template: viewTpl,
    filtersName: 'leadsListFilters',

    gridOptions: function (data) {
      var options = CustomersListView.prototype.gridOptions.call(this, data);

      options.onSelectRow = function (rowid, bool, e) {
        if (!$(e.target).hasClass('cell-delete') && e.type === 'click' && !CustomersListView.isCheckboxClick(e)) {
          App.trigger('leads:show', rowid);
        }
      };

      return options;
    },

    _onAction: function (action) {
      switch (action) {
        case 'export':
          window.open(Settings.url('compuzz2', 'endusers.json/excel', {userType: 'lead'}), '_self');
          break;
        case 'downloadImportTemplate':
          window.open(Settings.url('compuzz2', 'endusers.json/excel/template', {userType: 'lead'}), '_self');
          break;
        default:
          CustomersListView.prototype._onAction.call(this, action);
      }
    },

    onAddNew: function (e) {
      e.preventDefault();
      e.stopPropagation();

      Windows.open({
        view: _.bind(function () {
          var lead = App.request('customer:model');
          lead.set('userType', 'lead');
          return new EditView({
            customerModel: lead,
            newItem: true,
            countries: this.options.countries
          });
        }, this),
        title: _.i18n('leads.new', null, 'New lead'),
        configName: 'customerEdit'
      });
    }
  });

  module.exports = LeadsListView;
});

